import tinycolor from "tinycolor2";

const primary = "#121212";
const secondary = "#FF5C93";
const warning = "#c27a00";
const success = "#1f8a5b";
const info = "#9013FE";

const lightenRate = 7.5;
const darkenRate = 15;

const defaultTheme = {
  palette: {
    primary: {
      main: primary,
      light: tinycolor(primary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(primary)
        .darken(darkenRate)
        .toHexString(),
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(secondary)
        .darken(darkenRate)
        .toHexString(),
      contrastText: "#FFFFFF",
    },
    warning: {
      main: warning,
      light: tinycolor(warning)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(warning)
        .darken(darkenRate)
        .toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(success)
        .darken(darkenRate)
        .toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(info)
        .darken(darkenRate)
        .toHexString(),
    },
    text: {
      primary: "#1a1a1a",
      secondary: "#555555",
      hint: "#8a8a8a",
    },
    background: {
      default: "#f5f5f5",
      light: "#5c7a946b",
    },
  },
  typography: {
    fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif",
    fontSize: 14,
    button: { textTransform: "none", fontWeight: 500 },
  },
  shape: { borderRadius: 8 },
  customShadows: {
    widget:
      "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
    widgetDark:
      "0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
    widgetWide:
      "0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
  },
  overrides: {
    MuiButton: {
      root: { borderRadius: 999, textTransform: "none", fontWeight: 500, minHeight: 36, padding: "5px 18px", fontSize: "0.9rem" },
      contained: { boxShadow: "none", "&:hover": { boxShadow: "none" } },
      containedPrimary: { backgroundColor: "#121212", color: "#fff", "&:hover": { backgroundColor: "#333" } },
      outlined: { borderColor: "#1a1a1a", color: "#1a1a1a" },
      outlinedPrimary: { borderColor: "#1a1a1a", color: "#1a1a1a", "&:hover": { backgroundColor: "#ececec" } },
      textPrimary: { color: "#0b5cc2" },
    },
    MuiPaper: {
      rounded: { borderRadius: 14 },
      elevation1: { boxShadow: "none", border: "1px solid #d9d9d9" },
    },
    MuiInputBase: { root: { fontSize: "0.9rem" } },
    MuiOutlinedInput: {
      input: { padding: "9.5px 12px" },
      root: { borderRadius: 8, backgroundColor: "#fff", "&$focused $notchedOutline": { borderColor: "#1a1a1a", borderWidth: 2 } },
      notchedOutline: { borderColor: "#8f8f8f" },
    },
    MuiCheckbox: { root: { color: "#8f8f8f", padding: 6, "& svg": { fontSize: 20 } }, colorPrimary: { "&$checked": { color: "#121212" } }, colorSecondary: { "&$checked": { color: "#121212" } } },
    MuiChip: { root: { borderRadius: 999 } },
    MuiTableHead: { root: { backgroundColor: "#efefef" } },
    MuiFormLabel: {
      asterisk: {
        color: "#f44336",
        "&$error": {
          color: "#f44336",
        },
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: "#4A4A4A1A",
      },
    },
    MuiMenu: {
      paper: {
        boxShadow:
          "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
      },
    },
    MuiSelect: {
      icon: {
        color: "#B9B9B9",
      },
    },
    MuiListItem: {
      root: {
        "&$selected": {
          backgroundColor: "#e6e6e6 !important",
          "&:focus": {
            backgroundColor: "#e6e6e6",
          },
        },
      },
      button: {
        "&:hover, &:focus": {
          backgroundColor: "#ececec",
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: "white",
      },
    },
    MuiTableRow: {
      root: {
        height: 48,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "1px solid #d9d9d9",
        paddingLeft: 16,
        paddingTop: 6,
        paddingBottom: 6,
      },
      head: {
        fontSize: "0.9rem",
        fontWeight: 500,
        color: "#333",
        backgroundColor: "#efefef",
      },
      body: {
        fontSize: "0.95rem",
      },
    },
    PrivateSwitchBase: {
      root: {
        marginLeft: 10
      }
    }
  },
};

export default defaultTheme;
